/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_b64_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base64 Encode / Decode`)
};

const es_b64_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificador/Decodificador Base64`)
};

const de_b64_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base64 Kodierung / Dekodierung`)
};

const nl_b64_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base64 Coderen / Decoderen`)
};

const fr_b64_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codeur/Décodeur Base64`)
};

const it_b64_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base64 Codifica / Decodifica`)
};

const pt_br2_b64_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificador / Decodificador Base64`)
};

const pt_b64_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificar / Descodificar Base64`)
};

const ja_b64_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base64エンコード / デコード`)
};

const zh_b64_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base64 编码/解码`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const b64_tool_name = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.b64_tool_name(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("b64_tool_name", locale)
	if (locale === "en") return en_b64_tool_name(inputs)
	if (locale === "es") return es_b64_tool_name(inputs)
	if (locale === "de") return de_b64_tool_name(inputs)
	if (locale === "nl") return nl_b64_tool_name(inputs)
	if (locale === "fr") return fr_b64_tool_name(inputs)
	if (locale === "it") return it_b64_tool_name(inputs)
	if (locale === "pt-BR") return pt_br2_b64_tool_name(inputs)
	if (locale === "pt") return pt_b64_tool_name(inputs)
	if (locale === "ja") return ja_b64_tool_name(inputs)
	return zh_b64_tool_name(inputs)
};